// src/kunde/state.js
// Tilstand der deles på tværs af kunde-appens moduler.
//
// Da alt lå i én fil, var det her blot variabler i toppen. Med moduler
// skal delt tilstand have et sted at bo. Læsninger virker direkte via
// ES-modulers levende bindinger — importerer man `machines`, ser man
// altid den aktuelle værdi. Kun tildeling skal gå gennem en sætter,
// fordi man ikke må tildele til et importeret navn.

/** Brugerens session, eller null når ingen er logget ind. */
export let sess = null;

/** Brugerens maskiner, som de sidst blev hentet. */
export let machines = [];

/** Maskinen der er åben i service-dialogen. */
export let curMcId = null;

/** Valgt måned (0-11) og år i datovælgeren. */
export let selM = null;
export let selY = null;

/** Sat når datoen er aflæst automatisk fra et servicemærkat. */
export let aiDet = false;

export function setSess(v)     { sess = v; }
export function setMachines(v) { machines = v; }
export function setCurMcId(v)  { curMcId = v; }
export function setSelM(v)     { selM = v; }
export function setSelY(v)     { selY = v; }
export function setAiDet(v)    { aiDet = v; }

/** Nulstiller datovalget, når service-dialogen åbnes på ny. */
export function nulstilDatovalg(mcId) {
  curMcId = mcId;
  selM = null;
  selY = null;
  aiDet = false;
}
